export const CampaignTypes = {
  Shopping: _TL_('Shopping'),
  Default: _TL_('Search'),
  PerformanceMax: _TL_('Performance Max'),
  Audience: _TL_('Audience'),
};

export const DeviceTypes = {
  Computers: _TL_('Computers'),
  Smartphones: _TL_('Smartphones'),
  Tablets: _TL_('Tablets'),
};

export const seasonalityCampaignTypeToBulkUpsertValue = {
  Search: 'Search',
  Shopping: 'Shopping',
  PerformanceMax: 'PerformanceMax',
  Audience: 'Audience',
};

export const seasonalityCampaignTypeFromODataValue = {
  Default: 'Default',
  Shopping: 'Shopping',
  PerformanceMax: 'PerformanceMax',
  Audience: 'Audience',
};
